import { useState } from 'react';
import LazyLoad from "react-lazyload";
import { Modal } from 'react-bootstrap';
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const VocationalClub = () => {
    const homeMenu = [
        { label: "MUN", link: "/Mun" },
        { label: "Glory to the Nation", link: "/GloryOfNation" },
        { label: "Spic Macay Cultural and Heritage Club", link: "/SpocmacyColtoralHeritage" },
        { label: "Vocational Education Clubs (Middle Wing) ", link: "/vocationalClubmiddle" },
        { label: "Vocational Education Clubs (Senior Wing)", link: "/vocationalClub" },
        { label: "Vocational Education Clubs (Primary Wing)", link: "/VocationalClubPrimary" },
    ];

    const [showModal, setShowModal] = useState(false);
    const [selected, setSelected] = useState({ title: "", url: "" });

    const handleOpenModal = (title, url) => {
        setSelected({ title, url });
        setShowModal(true);
    };

    const handleCloseModal = () => setShowModal(false);

    const brochures = [
        { title: "ATL - e-Brochure", url: "https://online.anyflip.com/sdtqz/svfr/index.html" },
        { title: "LOTUS QUAD - e-Brochure", url: "https://online.anyflip.com/sdtqz/xkvf/index.html" },
        { title: "MOTHER TERESA - e-Brochure", url: "https://online.anyflip.com/sdtqz/ixeu/index.html" },
        { title: "SHARK TANK - e-Brochure", url: "https://online.anyflip.com/sdtqz/mpzv/index.html" },
        { title: "SOUND OF MUSIC - e-Brochure", url: "https://online.anyflip.com/sdtqz/msnn/index.html" },
        { title: "TED CLUB - e-Brochure", url: "https://online.anyflip.com/ktds/zbvr/index.html" },
        { title: "THE CREATIVE POD - e-Brochure", url: "https://online.anyflip.com/ktds/amuy/index.html" },
        { title: "UNPARALLELED DEVOPS - e-Brochure", url: "https://online.anyflip.com/hjco/wbbc/index.html" },
        { title: "Culture and Heritage Club (Spic Macay) - e Brochure", url: "https://online.anyflip.com/ktds/viml/index.html" },
        { title: "Apostles of Shakespeare - e Brochure", url: "https://online.anyflip.com/ktds/nplb/index.html" },
        { title: "DANCEPIRATION - e Brochure", url: "https://online.anyflip.com/hjco/woji/index.html" },
        { title: "MASTERMINDS - e Brochure", url: "https://online.anyflip.com/hjco/wefj/index.html" },
        { title: "RHYTHM AND FUSION - e Brochure", url: "https://online.anyflip.com/hjco/axcc/index.html" },
        { title: "GLOBAL LEADERS - e Brochure", url: "https://online.anyflip.com/hjco/dmyn/index.html" },
        { title: "SIGMA CLUB - e Brochure", url: "https://online.anyflip.com/hjco/nckv/index.html" },
    ];

    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/blog-banner.jpg" />
            <Menu MenuItem={homeMenu} />

            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle
                                pageTitle="Vocational Education Clubs (Senior Wing)"
                                breadEnd="Vocational Education Clubs"
                                breadMid="Vocational Education Clubs (Senior Wing)"
                            />
                        </div>
                    </div>
                    <div className="row">
                        {brochures.map((item, index) => (
                            <div className="col-xl-3 col-md-6 col-sm-12" key={index}>
                                <div
                                    className="vocationalClub"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleOpenModal(item.title, item.url)}
                                >
                                    <LazyLoad>
                                        <img
                                            src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vocational-education-clubs.jpg"
                                            alt={item.title}
                                        />
                                    </LazyLoad>
                                    <p>{item.title}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={handleCloseModal} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{selected.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: '80vh' }}>
                    <iframe
                        src={selected.url}
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                        title={selected.title}
                    ></iframe>
                </Modal.Body>
            </Modal>

            <Footer />
        </>
    );
};

export default VocationalClub;
